import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SubscriptionGuard } from './_core/_guards/subscription.guard';

const routes: Routes = [
  {
    path: 'info/:infoPage',
    loadChildren: () => import('./modules/portal-info/portal-info.module').then(m => m.PortalInfoModule)
  },
  {
    path: 'play/:categoryId/:gameId',
    loadChildren: () => import('./modules/game-play/game-play.module').then(m => m.GamePlayModule),
    canLoad: [SubscriptionGuard]
  },
  {
    path: '',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }